// extracted by mini-css-extract-plugin
export default {"header":"ShowSelected__header--1zLgb","title":"ShowSelected__title--1GLcW","datalist":"ShowSelected__datalist--2ksjW"};